import React from "react";
import { Box, Link, Typography } from "@mui/material";

const Section2: React.FC = () => {
    return (
        <Box
            sx={{ px: {md: 2}, py: 2 }}
            display="flex"
            flexDirection="column"
            alignItems="center"
        >
            <Typography
                variant="body1"
                color="error.light"
                textAlign={"center"}
                maxWidth={1000}
            >
                IMPORTANT: After Buying SMRTY click on &quot;Portfolio&quot; above to copy
                your affiliate &quot;Sign-up Address&quot; from any of your NFTs to give
                to others so they can Sign Up! And be sure to click below to join our
                community.
            </Typography>

            <Link
                href="https://smartypants.exchange/jumptocommuntiy.htm"
                target="_blank"
            >
                <Typography
                    variant="body1"
                    color="primary.main"
                    maxWidth={600}
                    textAlign={"center"}
                    sx={{ mt: 4 }}
                >
                    Click Here to Join the SmartyPants Community to receive more
                    opportunities and follow important announcements including dates for
                    Holding-Rewards
                </Typography>
            </Link>
            <Box
                sx={{ px: {md: 2}, py: 2, "& strong": { color: "text.primary" } }}
                display="flex"
                flexDirection="column"
                alignItems="center"
            >
                <Typography
                    color="text.secondary"
                    maxWidth={600}
                    textAlign={"center"}
                    sx={{ mt: 4, mb: 2 }}
                    fontWeight={"bold"}
                    fontSize={"1.2rem"}
                >
                    TERMS & CONDITIONS:
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    textAlign={"justify"}
                >
                    Buy SMRTY today to begin receiving periodic{" "}
                    <strong>Holding-Rewards</strong>, based on their availability, after
                    the first 30,000 coins are sold.{" "}
                    <strong>
                        You must have a minimum of 50 SMRTY Coins in any wallet in order to
                        receive Holding-Rewards.
                    </strong>{" "}
                    Purchasing SMRTY during the ICO is the <strong>only way</strong> to
                    obtain our <strong>Affiliate-Rewards NFTs </strong>(
                    <strong>SmartyPass</strong>). The ICO will end sometime after the
                    first 2,000,000 coins are sold and will remain active as long as the
                    project developers perceive sufficient demand for the coin and
                    continued interest in earning Affiliate-Rewards. We will release our
                    own <strong>Order-Book Style Exchange</strong> on this website at some
                    point, either based on the perceived progress of the ICO or at its
                    conclusion. Get SMRTY coins from the ICO with{" "}
                    <strong>Affiliate-Rewards</strong> while they last!
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mt: 3, fontWeight: "bold", fontSize: "1.1rem" }}
                    textAlign={"justify"}
                >
                    Please read the rest of this page before proceeding, as it explains
                    certain restrictions imposed by law on the distribution of this
                    information and the jurisdictions in which our products and services
                    are authorised to be offered or sold. It is your responsibility to be
                    aware of and to observe all applicable laws and regulations of any
                    relevant jurisdiction.
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={3}
                >
                    <strong>SMRTY Coin</strong> is a <strong>utility token</strong>{" "}
                    designed to demonstrate the capabilities of the{" "}
                    <strong>SmartyPants platform</strong>, including{" "}
                    <strong>SmartyPass</strong> and the <strong>Exchange Platform</strong>
                    . It serves as a working example of how the system can be sold and
                    white-labeled by clients for use in lawful ways to promote their own
                    products and services. Proceeds from the sale of SMRTY Coin also help
                    fund the development of the SmartyPants system and support the growth
                    of the SmartyPants Community as an advertising and marketing vehicle.
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    <strong>SmartyPants Holding-Rewards are limited</strong> and provided
                    solely based on their availability and the ongoing desire of the
                    project leaders to distribute them. Holding-Rewards are{" "}
                    <strong>not guaranteed</strong>, but are used to demonstrate the
                    utility of the platform and to encourage users to buy and hold SMRTY
                    Coin in support of the project.
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    SMRTY Coin <strong>may</strong> be used in the future to access
                    discounts on platform purchases or to unlock additional rewards and
                    features—<strong>but no such uses are guaranteed</strong>. The coin is
                    not backed by any physical or financial asset, and its value derives
                    entirely from community interest and demand.
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    For all these reasons,{" "}
                    <strong>SMRTY Coin should not be considered a security</strong>. It is
                    best understood as a <strong>utility token and novelty item</strong>,
                    designed to showcase platform functionality and foster community
                    engagement
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    Although SMRTY is{" "}
                    <strong>not considered or intended to be a security</strong>, we have
                    implemented measures to help prevent U.S. residents from purchasing
                    the coin, in the event that it could be misinterpreted as one. These
                    measures include <strong>monitoring IP addresses</strong> of users
                    attempting to sign up for SMRTY and{" "}
                    <strong>restricting access to the exchange for U.S. residents</strong>
                    .
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    However, as this is a <strong>decentralized project</strong>, we
                    cannot fully prevent U.S. residents from acquiring SMRTY coins—whether
                    through indirect means, third parties, or by using tools that obscure
                    their location.
                    <strong>
                        Any U.S. resident who acquires SMRTY coins does so at their own risk
                        and assumes full responsibility
                    </strong>{" "}
                    for any losses or consequences resulting from their interaction with
                    the coin.
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    This same principle applies to all SMRTY coin holders, who accept full
                    responsibility for any and all risks associated with the use, holding,
                    or transfer of SMRTY coins.
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    By interacting with this site and/or buying, selling, recommending or
                    holding SMRTY you are agreeing that you have reviewed and agreed to
                    the terms contained herein, including any legal or regulatory
                    restrictions. By clicking &ldquo;Sign Up&rdquo; or interacting with
                    any area of this website you are acknowledging that you have read this
                    important information, you also: (i) agree that all access to this
                    website by you will be subject to the disclaimer, risk warnings and
                    other information set out herein; and (ii) agree that you are the
                    relevant sophistication level and/or type of audience intended for
                    your respective country or jurisdiction identified below. The
                    information contained on this website (this &ldquo;Website&rdquo;)
                    (including without limitation the information, functions and documents
                    posted herein (together, the &ldquo;Contents&rdquo;) is made available
                    for informational purposes only.
                </Typography>
                <Typography
                    fontSize={"1.1rem"}
                    color="text.secondary"
                    textAlign={"center"}
                    fontWeight={"bold"}
                    mt={4}
                >
                    No Offer
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    The Contents have been prepared without regard to the investment
                    objectives, financial situation, or means of any person or entity, and
                    the Website is not soliciting any action based upon them.
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    This material should not be construed as investment advice or a
                    recommendation or an offer or solicitation to buy or sell securities
                    and does not constitute an offer or solicitation in any jurisdiction
                    where or to any persons to whom it would be unauthorized or unlawful
                    to do so.
                </Typography>
                <Typography
                    fontSize={"1.1rem"}
                    color="text.secondary"
                    textAlign={"center"}
                    fontWeight={"bold"}
                    mt={4}
                >
                    Access Subject to Local Restrictions
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    <strong>
                        The Website is intended for the following audiences in each
                        respective country or region: In the U.S.
                    </strong>
                    , public distribution, however,{" "}
                    <strong>
                        SMRTY Coin is NOT for purchase by U.S. Residents. In Canada
                    </strong>
                    , public distribution. <strong>In the UK</strong>, professional
                    clients (as defined by the Financial Conduct Authority or MiFID Rules)
                    and qualified investors only and should not be relied upon by any
                    other persons. <strong>In the EEA</strong>, professional clients,
                    professional investors, qualified clients and qualified investors. For
                    qualified investors in Switzerland: This information is marketing
                    material. This material shall be exclusively made available to, and
                    directed at, qualified investors as defined in Article 10 (3) of the
                    CISA of 23 June 2006, as amended, at the exclusion of qualified
                    investors with an opting-out pursuant to Art. 5 (1) of the Swiss
                    Federal Act on Financial Services (&quot;FinSA&quot;).
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    For information on art. 8 / 9 Financial Services Act (FinSA) and on
                    your client segmentation under art. <strong>In Singapore</strong>,for
                    Institutional Investor only as defined in Section 4A of the Securities
                    and Futures Act, Chapter 289 of Singapore.{" "}
                    <strong>In Hong Kong</strong>, for professional Investor only (as
                    defined in the Securities and Futures Ordinance (Cap.571 of the Laws
                    of Hong Kong) and any rules made under that ordinance).{" "}
                    <strong>In Japan</strong>, Professional Investors only (Professional
                    Investor is defined in Financial Instruments and Exchange Act).{" "}
                    <strong>In Australia</strong>, for wholesale clients only as defined
                    in the Australian Corporations Act 2001 (Cth).{" "}
                    <strong>In Brunei, Indonesia, and Malaysia</strong>, Institutional
                    Investors only. <strong>In Latin America</strong>, institutional
                    investors and financial intermediaries only (not for public
                    distribution). <strong>In Mexico</strong>, institutional and qualified
                    investors only (not for public distribution).
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    This Contents are not intended for, or directed to, persons in any
                    countries or jurisdictions that are not enumerated above, or to an
                    audience other than as specified above.
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    This Website has not been, and will not be submitted to become,
                    approved/verified by, or registered with, any relevant government
                    authorities under the local laws. This Website is not intended for and
                    should not be accessed by persons located or resident in any
                    jurisdiction where (by reason of that person&apos;s nationality,
                    domicile, residence or otherwise) the publication or availability of
                    this Website is prohibited or contrary to local law or regulation or
                    would subject any SmartyPants related person, entity or holder to any
                    registration or licensing requirements in such jurisdiction.
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    It is your responsibility to be aware of, to obtain all relevant
                    regulatory approvals, licenses, verifications and/or registrations
                    under, and to observe all applicable laws and regulations of any
                    relevant jurisdiction in connection with your access. If you are
                    unsure about the meaning of any of the information provided, please
                    consult your financial or other professional adviser.
                </Typography>
                <Typography
                    fontSize={"1.1rem"}
                    color="text.secondary"
                    textAlign={"center"}
                    mt={4}
                    fontWeight={"bold"}
                >
                    No Warranty
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    The Contents are published in good faith but no advice, representation
                    or warranty, express or implied, is made by anyone associated with the
                    SmartyPants project or by any person as to its adequacy, accuracy,
                    completeness, reasonableness or that it is fit for your particular
                    purpose, and it should not be relied on as such. The Contents do not
                    purport to be complete and are subject to change. You acknowledge that
                    certain information contained in this Website supplied by third
                    parties may be incorrect or incomplete, and such information is
                    provided on an &ldquo;AS IS&rdquo; basis. We reserve the right to
                    change, modify, add, or delete, any content and the terms of use of
                    this Website without notice. Users are advised to periodically review
                    the contents of this Website to be familiar with any modifications.
                    The Website has not made, and expressly disclaims, any representations
                    with respect to any forward-looking statements. By their nature,
                    forward-looking statements are subject to numerous assumptions, risks
                    and uncertainties because they relate to events and depend on
                    circumstances that may or may not occur in the future.
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    No information on this Website constitutes business, financial,
                    investment, trading, tax, legal, regulatory, accounting or any other
                    advice. If you are unsure about the meaning of any information
                    provided, please consult your financial or other professional adviser.
                </Typography>
                <Typography
                    fontSize={"1.1rem"}
                    color="text.secondary"
                    textAlign={"center"}
                    fontWeight={"bold"}
                    mt={4}
                >
                    No Liability
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    Noone involved with the SmartyPants project, including SMRTY Coin
                    holders, traders or promoters shall have any liability for any loss or
                    damage arising in connection with this Website or out of the use or
                    from the value or lack of value of the SMRTY Coin, and the SmartyPass
                    NFT or inability to use or reliance on the Contents by any person,
                    including without limitation, any loss of profit or any other damage,
                    direct or consequential, regardless of whether they arise from
                    contractual or tort (including negligence) or whether SmartyPants has
                    foreseen such possibility, except where such exclusion or limitation
                    contravenes the applicable law.
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    You may leave this Website when you access certain links on this
                    Website. SmartyPants has not examined any of these websites and does
                    not assume any responsibility for the contents of such websites nor
                    the services, products or items offered through such websites.
                </Typography>
                <Typography
                    fontSize={"1.1rem"}
                    color="text.secondary"
                    textAlign={"center"}
                    fontWeight={"bold"}
                    mt={4}
                >
                    Intellectual Property Rights
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    Copyright, trademark and other forms of proprietary rights protect the
                    Contents of this Website. All Contents are owned or controlled by
                    SmartyPants or the party credited as the provider of the Content.
                    Except as expressly provided herein, nothing in this Website should be
                    considered as granting any license or right under any copyright,
                    patent or trademark or other intellectual property rights of
                    SmartyPants or any third party.
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    This Website is for your personal use. As a user, you must not sell,
                    copy, publish, distribute, transfer, modify, display, reproduce,
                    and/or create any derivative works from the information or software on
                    this Website. You must not redeliver any of the pages, text, images,
                    or content of this Website using &ldquo;framing&rdquo; or similar
                    technology. Systematic retrieval of content from this Website to
                    create or compile, directly or indirectly, a collection, compilation,
                    database or directory (whether through robots, spiders, automatic
                    devices or manual processes) or creating links to this Website is
                    strictly prohibited. You acknowledge that you have no right to use the
                    content of this Website in any other manner.
                </Typography>
                <Typography
                    fontSize={"1.1rem"}
                    color="text.secondary"
                    textAlign={"center"}
                    fontWeight={"bold"}
                    mt={4}
                >
                    Additional Information
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    textAlign={"justify"}
                    mt={2}
                >
                    <strong>
                        Investment involves risks. Past performance is not a guide to future
                        performance
                    </strong>
                    . The value of investments and the income from them can fall as well
                    as rise and is not guaranteed. You may not get back the amount
                    originally invested. Changes in the rates of exchange between
                    currencies may cause the value of investments to diminish or increase.
                </Typography>
            </Box>
        </Box>
    );
};

export default Section2;
